module.exports = __webpack_public_path__ + "media/images/mobile/solutions/27-b794454f16e4b529d0867422e4c35845.jpg";